import { wrap } from './common';
export function cordova(pluginObj, methodName, config, args) {
    return wrap(pluginObj, methodName, config).apply(this, args);
}
//# sourceMappingURL=cordova.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ionic-native/core/decorators/cordova.js
// module id = 1886
// module chunks = 0